import { Button, Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { PropertyHandlers } from "../state/actions";
import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";
const EditableTableCell = ({ description, taskId, getIndividualTransactionData, agentType, delegateSide, delegateOwnerId, screenType, isClientDashboard, dueDateHistory }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(description);
  const dispatch = useDispatch();

  const handleEdit = () => {
    if (!isClientDashboard) {
      setIsEditing(true);
    }
  };
  const renderHistoryTooltip = () => {
    if (!Array.isArray(dueDateHistory) || dueDateHistory.length === 0) {
      return null;
    }
    const reversed = [...dueDateHistory]
      .filter((entry) => {
        if (!entry || typeof entry !== "object" || !moment(entry.changedAt).isValid()) {
          return false;
        }
        // allowing to === null, but if it's not null, it must be valid
        if (entry.to != null && !moment(entry.to).isValid()) {
          return false;
        }
        if (entry.from != null && !moment(entry.from).isValid()) {
          return false;
        }
        return true;
      })
      .reverse();

    if (reversed.length === 0) {
      return null;
    }

    return (
      <div style={{ maxWidth: 280, maxHeight: 400, overflowY: "auto" }}>
        {reversed.map((entry, idx) => {
          const { from, to, changedAt } = entry;
          const formattedOld = from ? moment(from).format("MMM D, YYYY") : null;
          const formattedNew = to ? moment(to).format("MMM D, YYYY") : "Text Added";
          const formattedChangedAt = moment(changedAt).format("MMM D, YYYY, h:mm a");

          return (
            <div
              key={idx}
              style={{
                marginBottom: 12,
                paddingBottom: 8,
                paddingRight: 8,
                borderBottom: idx !== reversed.length - 1 ? "1px solid #ddd" : "none",
              }}
            >
              {from == null ? (
                <div>
                  <b>Due Date Added:</b> {formattedNew}
                </div>
              ) : (
                <div>
                  <b>Due Date Changed:</b>
                  <br />
                  <span style={{ color: "#333" }}>
                    {formattedOld} ➝ {formattedNew}
                  </span>
                </div>
              )}
              <div style={{ fontSize: 11, color: "#888", marginTop: 4 }}>
                <i>Updated on {formattedChangedAt}</i>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const handleAddNotes = () => {
    if (value === description) {
      setIsEditing(false);
      return;
    }

    let urlData = {
      description: value,
    };
    dispatch(PropertyHandlers.editCustomTask({ taskId, urlData, offerId: getIndividualTransactionData?.offerId, agentType, delegateSide, delegateOwnerId, screenType }));
    setIsEditing(false);
  };

  return (
    <td
      style={{
        fontWeight: "bolder",
        width: "25%",
        position: "relative",
      }}
      onClick={!isEditing ? handleEdit : undefined}
    >
      {isEditing && !isClientDashboard ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <textarea
            autoFocus
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={handleAddNotes}
            style={{
              width: "100%",
              resize: "none",
              fontWeight: "bold",
              fontSize: "14px",
              marginRight: "8px",
              minHeight: "100px",
            }}
          />
          <Button
            type="primary"
            onClick={handleAddNotes}
            style={{
              marginRight: "4px",
              padding: "5px 8px",
              backgroundColor: "#1890ff",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Done
          </Button>
        </div>
      ) : (
        <>
          <div style={{ position: "relative", paddingRight: "24px" }}>
            <span style={{ display: "block" }} dangerouslySetInnerHTML={{ __html: value || "" }} />
            {Array.isArray(dueDateHistory) && dueDateHistory.length > 0 && (
              <Tooltip placement="topLeft" title={renderHistoryTooltip()}>
                <InfoCircleOutlined
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    color: "orange",
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            )}
          </div>
        </>
      )}
    </td>
  );
};

export default EditableTableCell;
